export const initialShowState = {
  isShow: false,
  isShow2: false,
  isShow3: false,
  isShow4: false,
  isShow5: false,
  isShowGASTOS: false,
  isShowEditGASTOS: false,
  isShowAllGASTOS: false,
  isShowASIST: false,
};

export function showReducer(state, action) {
  switch (action.type) {
    case "SHOW":
      return { ...initialShowState, isShow: true };
    case "SHOW2":
      return { ...initialShowState, isShow2: true };
    case "SHOW3":
      return { ...initialShowState, isShow3: true };
    case "SHOW4":
      return { ...initialShowState, isShow4: true };
    case "SHOW5":
      return { ...initialShowState, isShow5: true };
    case "SHOWGASTOS":
      return { ...initialShowState, isShowGASTOS: true };
    case "SHOWEDITGASTOS":
      return { ...initialShowState, isShowEditGASTOS: true };
    case "SHOW_ALL_GASTOS":
      return { ...initialShowState, isShowAllGASTOS: true };
    case "SHOW_ASIST":
      return { ...initialShowState, isShowASIST: true };
       case "SHOW_FACTURAS":
      return { ...initialShowState, isShowFacturas: true };
       case "SHOW_NEWFACTURA":
      return { ...initialShowState, isShowNewFacturas: true };
    case "END":
      return { ...initialShowState };
    default:
      return state;
  }
}